export const TIMER_FLASHSALE = new Date().setHours(24, 0, 0, 0);